import { ReactNode, useRef } from "react"
import { DropdownBodyStyledWrapper } from "./DropdownBody.css"
interface IDropdownBodyProps {
    customOptions: ReactNode[]
    residualHeight: number
}
const FIXED_TOTAL_HEIGHT = 72 // Total height of padding dropdown, margin top

const DropdownBody = (props: IDropdownBodyProps) => {
    const { customOptions, residualHeight } = props
    const dropdownBodyRef = useRef<HTMLDivElement>(null)
    const dropdownChildRef = useRef<HTMLDivElement>(null)

    return (
        <DropdownBodyStyledWrapper
            isHaveScrollBar={dropdownBodyRef.current?.scrollHeight !== dropdownBodyRef.current?.clientHeight}
            maxHeight={-1}
            residualHeight={residualHeight - FIXED_TOTAL_HEIGHT}
            ref={dropdownBodyRef}
        >
            <div ref={dropdownChildRef}>
                {customOptions.map((item) => item)}
            </div>
        </DropdownBodyStyledWrapper>
    )
}

export default DropdownBody
